import TipSpoilService from '@/services/requests/tipSpoilService'
import ProjectTipService from '@/services/requests/projectTipService'

export default {
  data() {
    return {
      projectFilterEnabled: true
    }
  },
  methods: {
    filterListByTipSpoils(array, arrayIdProp, otherIdProp, otherSelectedValue) {
      return array.filter(item => {
        return !!this.tipSpoils.filter(combination => {
          return (
            combination[arrayIdProp] == item.id &&
            combination[otherIdProp] == otherSelectedValue
          )
        }).length
      })
    },
    async filterTipListByProject(array, projectId) {
      return array.filter(item => {
        return !!this.tipProjects.filter(combination => {
          //console.log('Check tips',combination.tipId, item.id, combination.projectId, projectId);
          return (
            combination.tipId == item.id && combination.projectId == projectId
          )
        }).length
      })
    }
    // getProjectId() {
    //     var projectId = null
    //     if(!!this.site) {
    //         console.log('site');
    //         projectId = this.site.projectId
    //     } else if (this[this.prefix].site) {
    //         console.log('prefix.site');
    //         projectId = this[this.prefix].site.projectId
    //     } else if (this[this.prefix].docket) {
    //         console.log('prefix.docket');
    //         projectId = this[this.prefix].docket.site.project.id
    //     } else {
    //         console.log('prefix');
    //         this[this.prefix].projectId
    //     }
    //     return projectId
    // }
  },
  computed: {
    // filteredTips() {
    //     if (!!this[this.prefix].spoilId) {
    //         //console.log(this.prefix);
    //         return this.filterListByTipSpoils(this.tips, 'tipId', 'spoilId', this[this.prefix].spoilId)
    //     } else {
    //         return this.tips
    //     }
    // },
    // filteredSpoils() {
    //     var tipId = null
    //     if(!this[this.prefix] && !this.tipId) return this.spoils
    //     if(!!this[this.prefix]) {
    //         console.log('Use tipId from obj');
    //         if (!!this[this.prefix].tipId) {
    //             return this.filterListByTipSpoils(this.spoils, 'spoilId', 'tipId', this[this.prefix].tipId)
    //         }
    //     } else {
    //         console.log('Use tipId', this.tipId);
    //         return this.filterListByTipSpoils(this.spoils, 'spoilId', 'tipId', this.tipId)
    //     }
    //     return this.spoils;
    // if (!!this[this.prefix].tipId) {
    //     return this.filterListByTipSpoils(this.spoils, 'spoilId', 'tipId', this[this.prefix].tipId)
    // } else {
    //     return this.spoils;
    // }
    // },
  },
  asyncComputed: {
    tipSpoils: {
      default: [],
      get() {
        var tipId = null
        var spoilId = null
        if (!!this.tipId) tipId = this.tipId
        if (!!this[this.prefix])
          !tipId ? (tipId = this[this.prefix].tipId) : tipId
        if (!!this.spoilId) spoilId = this.spoilId
        if (!!this[this.prefix])
          !spoilId ? (spoilId = this[this.prefix].spoilId) : spoilId
        //IDs: ',this[this.prefix], tipId, spoilId);

        //if(!tipId && !spoilId ) return []
        //if(!this[this.prefix] && !this.tipId ) return []
        // var tipId = !!this.tipId ? this.tipId : this[this.prefix].tipId
        // var spoilId = !!this.spoilId ? this.spoilId : this[this.prefix].spoilId
        if (!tipId && !spoilId) return []
        if (!!tipId && !!spoilId && !!this.tipSpoils.length) {
          //console.log("existed");
          return this.tipSpoils
        }
        var primaryId
        var type
        if (!!tipId) {
          type = 'tip'
          primaryId = tipId
        } else {
          type = 'spoil'
          primaryId = spoilId
        }
        //console.log('TipSpoil:', primaryId, type);

        return TipSpoilService.getTipSpoilsById(primaryId, type)
          .then(result => {
            return result.data.result
          })
          .catch(err => {
            this.snackError()
            console.log(err)
            return []
          })
      }
    },
    tipProjects: {
      default: [],
      get() {
        //var projectId = this.getProjectId()

        if (!this.projectId) {
          return []
        }
        return ProjectTipService.getProjectTipsById(this.projectId, 'project')
          .then(result => {
            //console.log(result.data.result)
            return result.data.result
          })
          .catch(err => {
            this.snackError()
            console.log(err)
            return []
          })
      }
    },
    async filteredTips() {
      //var projectId = this.getProjectId()
      console.log(
        'FILTERED TIPS - ENABLED:',
        this.projectFilterEnabled,
        'PROJECT ID:',
        this.projectId,
        'SPOIL ID:',
        this.spoilId
      )
      if (!!this.projectId && this.projectFilterEnabled) {
        var firstFilteredList = await this.filterTipListByProject(
          this.tips,
          this.projectId
        )

        if (!!this.spoilId) {
          return this.filterListByTipSpoils(
            firstFilteredList,
            'tipId',
            'spoilId',
            this.spoilId
          )
        } else {
          return firstFilteredList
        }
      } else {
        return this.tips
      }
    },
    async filteredSpoils() {
      var tipId = null
      if (!this[this.prefix] && !this.tipId) return this.spoils

      if (!!this[this.prefix]) {
        //console.log('Use tipId from obj', this[this.prefix].tipId);

        if (!!this[this.prefix].tipId) {
          //console.log('Found tipId in obj');
          return await this.filterListByTipSpoils(
            this.spoils,
            'spoilId',
            'tipId',
            this[this.prefix].tipId
          )
        } else {
          //console.log('No tipId in obj');
          return this.spoils
        }
      } else {
        //console.log('Use tipId', this.tipId);
        return await this.filterListByTipSpoils(
          this.spoils,
          'spoilId',
          'tipId',
          this.tipId
        )
      }

      return this.spoils

      // if (!!this[this.prefix].tipId) {
      //     return this.filterListByTipSpoils(this.spoils, 'spoilId', 'tipId', this[this.prefix].tipId)
      // } else {
      //     return this.spoils;
      // }
    }
  }
}
